
export const formatDateToYYYYMMDD = function (dateString, isEndDate) {
  const date = new Date(dateString);

  if (isEndDate) {
    date.setDate(date.getDate() + 1); // Add one day if isEndDate is true
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
export const alertLevels = {
  0: "Info",
  1: "Warning",
  2: "Critical",
};

export const statusLabels = {
  1: "Resolved",
  0: "Unresolved",
};

export const formatUtcToLocal = (dateString) => {
  // Return empty string for specific invalid dates
  if (!dateString || dateString === "0001-01-01 00:00:00.000000") {
    return "";
  }

  const utcDate = new Date(dateString);

  // Check if the date is valid
  if (isNaN(utcDate)) {
    return "";
  }

  // Format the date to local time string
  return utcDate.toLocaleString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};


